import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import MarkdownIt from "markdown-it";
import MdEditor from "react-markdown-editor-lite";

import styles from "./style.module.css";
import { CMSTypes } from "../../interfaces";
import { FAQSchema } from "../../features/cms/validations";
import { CONSTANTS } from "../../lib/constants/messages";
import { uploadFile } from "../../features/blogs/api";
import { updateFAQ, createFAQ, updateTroubleShoot, createTroubleShoot } from "../../features/cms/api";
import { addCMSCountry, updateCountryBlogs } from "../../features/cmscountry/api";
import { useParams } from "react-router-dom";
import { CMS_TYPE } from "../../lib/constants";
import { BlogSchema } from "../../features/cmscountry/validations";

interface PopupType {
  show: boolean;
  handleClose: () => void;
  getFaqs: () => void;
  faq: any | null;
  typeOfPage?:number;
  cmsId?:string;
  faqIndex?:number;
};

const CreateUpdateFAQPopup = (props: PopupType) => {  
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [imageUploading, setImageUploading] = useState(false);
  const { id } = useParams<{ id: string }>();

  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });
  
  

  const faqFormik = useFormik({
    initialValues:{
      title: "",
      author: "",
      slug: "",
      readTime: "",
      
      content: "",
      featuredImage: "",
    },
    onSubmit: (values) => {
      const payload = {
        blogPosts:[
          {
            title: values.title,
            author: values.author,
            content: values.content,
            featuredImage: values.featuredImage, 
            readTime: values.readTime,
            slug: values.slug,
          }
        ],
        countryId: id,
        type: props.typeOfPage,
      }

      const getPayload = props.faq ? {
        blogData:{
            title: values.title,
            author: values.author,
            content: values.content,
            featuredImage: values.featuredImage, 
            readTime: values.readTime,
            slug: values.slug,
          },
        
        cmsId: props.cmsId,
        blogIndex: props.faqIndex,
      }:payload

      toast.promise(

            props.faq ? updateCountryBlogs(getPayload) : addCMSCountry(payload),
            {
              pending: {
                render() {
                  return props.faq ? CONSTANTS.CMS.UPDATING : "Adding CMS";
                }
              },
              success: {
                render() {
                  props.getFaqs();
    
                  if (!props.faq) faqFormik.resetForm();
    
                  props.handleClose();
                  return props.faq ? CONSTANTS.CMS.SUCCESS : "Successfully Added";
                }
              },
              error: {
                render() {
                  return props.faq ? CONSTANTS.CMS.FAILED : "Failed to Add";
                }
              }
            }
          )
    
      
     
    //   const getPayload:any = props.typeOfPage === 8
    //   ? { ...values, faqId: values.faqId}
    //   : { ...values, TroubleShootId: values.TroubleShootId};
  
    //   toast.promise(

    //     props.faq ? props.typeOfPage == 8 ? updateFAQ(getPayload) : updateTroubleShoot(getPayload) : props.typeOfPage == 8 ? createFAQ(values) : createTroubleShoot(values),
    //     {
    //       pending: {
    //         render() {
    //           return props.faq ? CONSTANTS.FAQ.UPDATING : CONSTANTS.FAQ.CREATING;
    //         }
    //       },
    //       success: {
    //         render() {
    //           props.getFaqs();

    //           if (!props.faq) faqFormik.resetForm();

    //           props.handleClose();
    //           return props.faq ? CONSTANTS.FAQ.UPDATE_SUCCESS : CONSTANTS.FAQ.CREATE_SUCCESS;
    //         }
    //       },
    //       error: {
    //         render() {
    //           return props.faq ? CONSTANTS.FAQ.UPDATE_FAILED : CONSTANTS.FAQ.CREATE_FAILED;
    //         }
    //       }
    //     }
    //   )
    },
    // validationSchema: FAQSchema,
    validationSchema: BlogSchema,
  });

  const handleMainImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setImageUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    uploadFile(formData)
      .then(res => {
        const imageUrl = res.data.url;
        setUploadedImage(imageUrl);
        faqFormik.setFieldValue("featuredImage", imageUrl);
        setImageUploading(false);
        toast.success("Image uploaded successfully!");
      })
      .catch(error => {
        setImageUploading(false);
        toast.error("Failed to upload image");
        console.error("Image upload error:", error);
      });
  };

  const removeImage = () => {
    setUploadedImage(null);
    faqFormik.setFieldValue("featuredImage", "");
  };

  const handleImageUpload = (file: any, callback: any) => {
    const reader = new FileReader()
    reader.onload = () => {

      const convertBase64UrlToBlob = (urlData: any) => {
        let arr = urlData.split(","), mime = arr[0].match(/:(.*?);/)[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      }
      convertBase64UrlToBlob(reader.result);

      const formData = new FormData();
      formData.append("file", file);

      uploadFile(formData).then(res => {
        callback(res.data.url);
      });
    }
    reader.readAsDataURL(file)
  }

  const closePopup = () => {
    props.handleClose();
    faqFormik.resetForm();
    setUploadedImage(null);
  };

  useEffect(() => {
    if (props.faq) {
      const values:any = {
        [props.typeOfPage === CMS_TYPE.BLOGS ? "blogId" : "TroubleShootId"]: props.faq._id,
        title: props.faq.title,
        author: props.faq.author,
        content: props.faq.content,
        featuredImage: props.faq.featuredImage || "",
        readTime: props.faq.readTime,
        slug: props.faq.slug,
      };
      setUploadedImage(props.faq.featuredImage || null);
      
      faqFormik.setValues(values);
    //   setUploadedImage(props.faq.imageUrl || null);
    }
  }, [props.faq])

  return (
    <Modal size="xl" show={props.show} onHide={props.handleClose}>
      <Modal.Header className={styles.modHead}>
        <Modal.Title>{props.typeOfPage === CMS_TYPE.BLOGS ? "Create Blog" : "Create FAQ"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.faqContent}>
        <div className="mb-3">
          <label className="w-100 mb-1">
            Title
            {
              faqFormik.touched.title && faqFormik.errors.title ?
                <span className="error">{faqFormik.errors.title}</span>
                :
                null
            }
          </label>
          <input
            className={styles.input}
            type="text"
            placeholder="Title"
            name="title"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.title}
          />
        </div>
        <div className="mb-3">
          <label className="w-100 mb-1">
            By
            {
              faqFormik.touched.author && faqFormik.errors.author ?
                <span className="error">{faqFormik.errors.author}</span>
                :
                null
            }
          </label>
          <input
            className={styles.input}
            type="text"
            placeholder="Author"
            name="author"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.author}
          />
        </div>

        <div className="mb-3">
          <label className="w-100 mb-1">
            Upload Image
          </label>
          <input
            className={styles.input}
            type="file"
            accept="image/*"
            onChange={handleMainImageUpload}
            disabled={imageUploading}
          />
          {imageUploading && (
            <div className="mt-2">
              <small className="text-info">Uploading image...</small>
            </div>
          )}
          {uploadedImage && (
            <div className="mt-3">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <label className="mb-0">Image Preview:</label>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={removeImage}
                >
                  Remove Image
                </button>
              </div>
              <div className="border rounded p-2" style={{ maxWidth: '400px' }}>
                <img
                  src={uploadedImage}
                  alt="Uploaded preview"
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '200px',
                    objectFit: 'cover',
                    borderRadius: '4px'
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <label className="w-100 mb-1">
          URL
          {
            faqFormik.touched.content && faqFormik.errors.content ?
              <span className="error">{faqFormik.errors.content}</span>
              :
              null
          }

        </label>
        <input
            className={styles.input}
            type="text"
            placeholder="URL"
            name="content"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.content}
          />
           <label className="w-100 mb-1">
          Read Time
          {
            faqFormik.touched.readTime && faqFormik.errors.readTime ?
              <span className="error">{faqFormik.errors.readTime}</span>
              :
              null
          }

        </label>
        <input
            className={styles.input}
            type="text"
            placeholder="Read Time"
            name="readTime"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.readTime}
          />
           <label className="w-100 mb-1">
          Slug
          {
            faqFormik.touched.slug && faqFormik.errors.slug ?
              <span className="error">{faqFormik.errors.slug}</span>
              :
              null
          }

        </label>
        <input
            className={styles.input}
            type="text"
            placeholder="Slug"
            name="slug"
            onChange={faqFormik.handleChange}
            onBlur={faqFormik.handleBlur}
            value={faqFormik.values.slug}
          />
          
        
      </Modal.Body>
      <Modal.Footer className={styles.modFoter}>
        <button type="button" className={styles.close} onClick={closePopup}>Close</button>
        <button type="submit" className={styles.button} onClick={faqFormik.submitForm}>Save Changes</button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateUpdateFAQPopup;